import { getActiveElement as y } from "../../../utils/helpers.js";
import { s as d } from "../../../Popover.module-B-m2_dp_.js";
import { t as r } from "../../../index.esm-0HiRSPBR.js";
const w = (t, n, i) => {
  var u;
  const s = (t == null ? void 0 : t.type) && ["listbox", "menu", "tree"].includes(t.type), a = n === "inline", l = () => {
    setTimeout(() => {
      var e, m;
      y() === t.api.elements.floating && ((m = (e = t.list.current) == null ? void 0 : e[0]) == null || m.focus());
    });
  }, c = (e) => {
    b(t, e), !t.disabledAutoToggle && g(t, e);
  }, f = t.interactions.getFloatingProps({
    onFocus: l,
    onKeyDown: c
  });
  return {
    ...f,
    "aria-orientation": s ? f == null ? void 0 : f["aria-orientation"] : void 0,
    role: t != null && t.hasInnerRole() || t == null ? void 0 : t.type,
    style: {
      ...i,
      ...a ? {} : (u = t == null ? void 0 : t.api) == null ? void 0 : u.floatingStyles
    }
  };
}, b = (t, n) => {
  if (!t.type || !["menu", "listbox"].includes(t.type) || n.key !== "Tab")
    return;
  n.preventDefault();
  const i = t.api.elements.reference;
  if (n.shiftKey && i.focus(), !n.shiftKey) {
    t.setShow(!1);
    const s = r(document.documentElement).filter(
      (c) => !c.closest(`.${d.content}`) && !c.hasAttribute("data-floating-ui-focus-guard")
    ), a = s.indexOf(i), l = s[a + 1];
    if (a === -1 || !l)
      return;
    l.focus();
  }
}, g = (t, n) => {
  t.type !== "listbox" || n.key !== "ArrowUp" || t.activeIndex !== 0 || t.setShowWithReason(!1, n.nativeEvent, "list-navigation");
};
export {
  w as composePopoverFloatingProps
};
